let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lc1q7")).then(() => parcelRequire('aKp87'));